import React from 'react'
import CreateAssets from '../PureComponents/CreateAssets'

const RenderCreateAssets = () => {
  return (
   <CreateAssets/>
  )
}

export default RenderCreateAssets